import { Link } from "@mui/material";
import { NotificationWorkspaceDto } from "generated/CoreApi_v1";
import React from "react";
import { Link as RouterLink } from "react-router";
import { FoundationPaths } from "routes/FoundationRouter";
import { KnowledgePaths } from "routes/KnowledgeRouter";
import { LmsPaths } from "routes/LmsRouter";
import { DirectMessageDialog } from "views/foundation/directMessage/DirectMessageDialog";

////////////////////////////////////////////////////////////////////////////////

export class PriorityMessageResolver {

    private renderDialog: (dialog: any) => void;

    private resolveActionCommand(command: string | null) {
        if (command == "AssCorrection") return LmsPaths.EvaluationCorrection;
        if (command == "LmsApproval") return LmsPaths.Approvals;
        if (command == "LmsTutoring") return LmsPaths.Supervisor;
        if (command == "KnowledgeModeration") return KnowledgePaths.FeedModeration;
        if (command == "ManagerEfficacy") return LmsPaths.ManagerEfficacy;
        if (command == "UserAutoRegisterPendings") return FoundationPaths.ManageAutoRegisterApprovals;

        return "#";
    }

    constructor(renderDialog: (dialog: any) => void) {
        this.renderDialog = renderDialog;
    }

    getMessage(notification: NotificationWorkspaceDto) {
        const tokens: React.ReactNode[] = [];

        if (notification.priorityNotification != null) {
            notification.priorityNotification.forEach((item, index) => {
                if (item.isAction) {
                    if (item.actionCommand !== "DirectMessages") {
                        tokens.push(
                            <Link key={index} to={this.resolveActionCommand(item.actionCommand)} component={RouterLink}>
                                {item.text}
                            </Link>
                        );
                    }
                    else {
                        tokens.push(
                            <Link
                                key={index}
                                onClick={() =>
                                    this.renderDialog(<DirectMessageDialog
                                        onClose={() => this.renderDialog(null)}
                                    />)
                                }
                            >
                                {item.text}
                            </Link>
                        );
                    }
                }
                else {
                    const Component = item.bold ? "b" : "span";
                    tokens.push(<Component key={index}>{item.text}</Component>);
                }

                if (item.addNewLine) tokens.push(<br key={index} />);
                else tokens.push(<span key={index}>&nbsp;</span>);
            });
        }

        return tokens;
    }
}
